import { apiClient } from './client';

export const resourceConfigApi = apiClient.injectEndpoints({
    endpoints: (builder: any) => ({
        getResourceConfig: builder.query({
            query: (productType: string) => ({
                url: '/api/config/resource',
                method: 'GET',
                params: { product: productType },
            }),
        }),
    }),
});

export const { useGetResourceConfigQuery } = resourceConfigApi;
